<template>
  <div class="info-wrap" v-loading="loading">
    <el-tabs tab-position="left" style="height: 100%">
      <el-tab-pane label="基础信息">
        <el-form ref="formInfo" :model="formInfo" label-width="120px">
          <el-form-item label="计量点id">
            <el-input :disabled="true" v-model="formInfo.id"></el-input>
          </el-form-item>
          <el-form-item label="测量点名称">
            <el-input v-model="formInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="使用模板">
            <el-input
              :disabled="true"
              v-model="formInfo.templateName"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在组织架构">
            <label>{{ formInfo.mountedOnName }}</label>
            <el-button type="text" @click="visibleOrg1 = true">更改</el-button>
          </el-form-item>
          <el-form-item label="排序编号">
            <el-input-number v-model="orderNum"></el-input-number>
          </el-form-item>
          <el-form-item label="所属节点">
            <el-select v-model="parentId">
              <el-option
                v-for="(item, index) in nodeData"
                :key="index"
                :value="item.id"
                :label="item.measureName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="formInfo.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="savaMeasure">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
        v-for="(item, index) in propertyGroups"
        :key="index"
        :label="item.displayName"
      >
        <el-form
          :ref="'form' + item.name"
          :model="form[item.name]"
          label-width="120px"
          :rules="rules"
        >
          <el-form-item
            v-for="(obj, key) in item.properties"
            :prop="obj.name"
            :label="obj.displayName"
            :key="key"
          >
            <el-date-picker
              style="width: 100%"
              v-if="obj.regulation.valueType == 4"
              v-model="form[item.name][obj.name]"
              :disabled="obj.regulation.changeable == 0 ? true : false"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
            <el-select
              style="width: 100%"
              v-else-if="obj.regulation.valueType == 5"
              :disabled="obj.regulation.changeable == 0 ? true : false"
              v-model="form[item.name][obj.name]"
            >
              <el-option
                v-for="(items, index) in enumPageData[obj.name]"
                :key="index"
                :label="items.displayName"
                :value="items.name"
              ></el-option>
            </el-select>
            <el-input
              v-else
              :disabled="obj.regulation.changeable == 0 ? true : false"
              v-model="form[item.name][obj.name]"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save(item.name)">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <!-- 组织架构 -->
    <div>
      <el-dialog
        title="选择组织架构"
        :visible.sync="visibleOrg1"
        width="500px"
        :close-on-click-modal="false"
        :modal="false"
      >
        <div>
          <el-tree
            class="filter-tree"
            :data="orgTreeData"
            node-key="id"
            default-expand-all
            @node-click="orgNodeClick"
            :highlight-current="true"
          >
            <span class="span-ellipsis" slot-scope="{ node, data }">
              <span :node="node" :title="data.name">{{ data.name }}</span>
            </span>
          </el-tree>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from "../../../../../common/api/index";
import tree from "@/utils/tree";
export default {
  props: {
    measureId: {
      type: String,
      default: "",
    },
    measure: {
      type: Object,
      default() {
        return {};
      },
    },
    nodeData: {
      type: Array,
      default() {
        return [];
      },
    },
    viewId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      propertyGroups: [],
      form: {},
      rules: {},
      loading: false,
      changeables: {},
      optionsData: [],
      formInfo: {},
      templates: [],
      orgStructNode: [],
      visibleOrg1: false,
      orgTreeData: [],
      enumData: [],
      enumPageData: {},
      parentId: 0,
      orderNum: 0,
    };
  },
  watch: {
    measureId(val) {
      if (val && val.length > 0) {
        this.getorgStructNode();
      }
    },
  },
  created() {
    this.getTemplates();
  },
  methods: {
    getTemplates() {
      api.measure.getMeasureTemplates().then((res) => {
        this.templates = res.data;
        this.getorgStructNode();
      });
    },
    getorgStructNode() {
      api.orgStructNode
        .getORGStructNodes(this.measure.measureCompanyId)
        .then((res) => {
          this.orgTreeData = tree.creatTreeJson(res.data, 0);
          this.orgStructNode = res.data;
          api.enumClass
            .getSubEnumClasses2("", 0, this.measure.measureCompanyId)
            .then((classRes) => {
              this.enumData = classRes.data;
              this.getData(this.measureId);
            });
        });
    },
    async getData(id) {
      this.loading = true;
      this.optionsData = [];
      let ids = [id];
      let res = await api.measure.getMeasuresProperties(JSON.stringify(ids));
      //生成表单
      let form = {};
      let rules = {};
      //页面枚举
      let enumPageData = {};
      let propertyGroups = res.data[0].propertyGroups;
      this.formInfo = res.data[0];
      this.parentId = this.measure.parentId;
      this.orderNum = this.measure.orderNum ? Number(this.measure.orderNum) : 0;
      this.formInfo.templateName = this.templates.find(
        (c) => c.id == this.formInfo.templateId
      ).displayName;
      this.formInfo.mountedOnName = this.orgStructNode.find(
        (c) => c.id == this.formInfo.mountedOn
      ).name;
      propertyGroups = propertyGroups.sort((a, b) => a.orderNum - b.orderNum);
      this.propertyGroups = propertyGroups;
      for (let i = 0; i < propertyGroups.length; i++) {
        form[propertyGroups[i].name] = {};
        propertyGroups[i].properties = propertyGroups[i].properties.sort(
          (a, b) => a.orderNum - b.orderNum
        );
        this.optionsData.push([]);
        for (let j = 0; j < propertyGroups[i].properties.length; j++) {
          const element = propertyGroups[i].properties[j];
          form[propertyGroups[i].name][element.name] = element.value;
          this.optionsData[i].push({
            name: element.regulation.enumClass,
            valueType: element.regulation.valueType,
            data: [],
          });
          if (element.regulation.changeable == 0) {
            this.changeables[element.name] = true;
          }
          //设置不能为空
          if (element.regulation.canValueEmpty == 0) {
            rules[element.name] = [
              {
                required: true,
                message: element.displayName + "不能为空",
              },
            ];
          }
          if (element.valueType == 1 || element.valueType == 2) {
            const ruleItem = {
              type: "number",
              message: element.displayName + "必须为数字值",
            };
            if (rules[element.name]) {
              rules[element.name].push(ruleItem);
            } else {
              rules[element.name] = [ruleItem];
            }
          }

          if (element.regulation.valueType == 5) {
            const enumItem = this.enumData.find(
              (c) => c.name == element.regulation.enumClass
            );
            const list = this.enumData.filter((c) => c.parentId == enumItem.id);

            enumPageData[element.name] = list;
          }
        }
      }
      this.enumPageData = enumPageData;
      this.rules = rules;
      this.form = form;
      this.loading = false;
    },
    save(name) {
      let vm = this;
      this.$nextTick(function () {
        let formName = "form" + name;
        let form = this.$refs[formName][0];
        form.validate((valid) => {
          if (valid) {
            let arr = [];
            let formObj = vm.form[name];
            for (let key in formObj) {
              if (!vm.changeables[key]) {
                arr.push({ name: key, value: formObj[key] });
              }
            }

            api.measure
              .setMeasureProperties(vm.measureId, JSON.stringify(arr))
              .then((res) => {
                if (res.success) {
                  vm.$message("保存成功！");
                } else {
                  vm.$message.error(res.msg);
                }
              });
          } else {
            return false;
          }
        });
      });
    },
    orgNodeClick(data) {
      this.formInfo.mountedOnName = data.name;
      this.formInfo.mountedOn = data.id;
      this.visibleOrg1 = false;
    },
    savaMeasure() {
      let vm = this;
      let apiArr = [];
      console.log(vm.measure);
      if (
        vm.measure.parentId !== vm.parentId ||
        vm.measure.orderNum !== vm.orderNum
      ) {
        apiArr.push(
          api.view.modifyMeasureContainingItem(
            vm.viewId,
            vm.parentId,
            vm.measure.measureId,
            vm.orderNum
          )
        );
      }
      apiArr.push(
        api.measure.modifyMeasure(
          vm.formInfo.id,
          vm.formInfo.name,
          vm.formInfo.remark,
          vm.formInfo.templateId,
          vm.formInfo.salespersonId,
          vm.formInfo.mountedOn
        )
      );

      Promise.all(apiArr).then((array) => {
        let bol = false;
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          if (!element.success) {
            bol = true;
            vm.$message.error(element.msg);
          }
        }
        if (!bol) {
          vm.$message("保存成功！");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.info-wrap {
  width: 90%;
  margin: 0px auto;
  height: 100%;
}
.title {
  font-size: 20px;
  padding: 10px 0px;
}
.content {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    width: 100%;
  }
  .item {
    width: 100%;
    padding: 0px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-bottom: 6px;
    .item-title {
      padding-right: 6px;
      width: 80px;
      flex: 0 0 80px;
      text-align: right;
    }
  }
}
</style>